import axios from "axios";
const API_URL = "https://api.farmasite.com.ar";

export const login = (credentials) =>
  axios.post(`${API_URL}/login`, credentials);

export const forgotPass = (credentials) =>
  axios.post(`${API_URL}/forgotpass`, credentials);

export const getFarmacia = (cuit) =>
  axios.post(`${API_URL}/getFarmacia`, { cuit });

export const resetPass = (credentials) =>
  axios.post(`${API_URL}/resetPassword`, credentials);

//Editar perfil

export const setBannerAws = (base64String, token) => {
  return axios.post(
    `${API_URL}/setBannerAws`,
    { image: base64String },
    {
      headers: {
        "x-access-token": token,
      },
    }
  );
};

export const setBanner = (url, token) => {
  return axios.post(
    `${API_URL}/setBanner`,
    { image: url },
    {
      headers: {
        "x-access-token": token,
      },
    }
  );
};

export const setLogo = (url, token) => {
  return axios.post(
    `${API_URL}/setLogo`,
    { image: url },
    {
      headers: {
        "x-access-token": token,
      },
    }
  );
};

export const setLogoAws = (base64String, token) => {
  return axios.post(
    `${API_URL}/setLogoAws`,
    { image: base64String },
    {
      headers: {
        "x-access-token": token,
      },
    }
  );
};

export const setbackimageColor = (color, token) => {
  return axios.post(
    `${API_URL}/setbackimageColor`,
    { color },
    {
      headers: {
        "x-access-token": token,
      },
    }
  );
};

export const updateFarmaciaInfo = async (nombre, mail, telefono, ab_id, token) => {
  return axios.post(
    `${API_URL}/setfarmainfo`,
    { nombre, mail, telefono, ab_id },
    { headers: { "x-access-token": token } }
  );
};

export const checkABuser = (ab_id, password, token) => {
  return axios.post(
    `${API_URL}/checkABuser`,
    { ab_id, password },
    { headers: { "x-access-token": token } }
  );
};

export const changePassword = async (newPassword, token) => {
  return axios.post(
    `${API_URL}/changepass`,
    { newPassword },
    { headers: { "x-access-token": token } }
  );
};